/**
 * co-collection-card-variant — wires the inline variant dropdown on compact product cards
 * (collection + search grids). Rendered by co-element-buy-buttons with variant_select: true.
 *
 * The <select data-co-variant-select> has NO name (so it never posts twice). On change it:
 *   1. writes the chosen variant id into the form's hidden <input name="id" ref="variantId">,
 *      which is what product-form.js submits via FormData;
 *   2. updates the card's displayed price from the option's Liquid-formatted data-price;
 *   3. reflects availability on the add-to-cart button (sold-out options are already disabled).
 *
 * Delegated at the document level so cards appended later (infinite scroll / pagination) work
 * with no re-init. Guarded so multiple sections loading this file only bind once.
 */
(function () {
  if (window.__coCardVariantInit) return;
  window.__coCardVariantInit = true;

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var select = target.closest('select[data-co-variant-select]');
    if (!select) return;

    var option = select.options[select.selectedIndex];
    if (!option) return;

    // Scope everything to the single product card / form this select belongs to.
    // [data-co-card] / [data-co-card-price] are the generic hooks for compact cards outside
    // the collection grid (e.g. the homepage "Most loved" slider).
    var card = select.closest('.co-collection-card, [data-co-card]');
    var scope = card || select.closest('product-form-component') || document;

    // 1) drive the hidden variant id the form actually submits
    var idInput = scope.querySelector('input[name="id"]');
    if (idInput) idInput.value = option.value;

    // 2) update the shown price (data-price is pre-formatted by Liquid: money_with_currency)
    if (card && option.dataset.price) {
      var priceEl = card.querySelector('.co-collection-card-price, [data-co-card-price]');
      if (priceEl) priceEl.textContent = option.dataset.price;
    }

    // 3) guard the add button (disabled options can't be selected, but cover zero-available)
    var button = scope.querySelector('.add-to-cart-button');
    if (button) button.disabled = option.dataset.available !== 'true';
  });
})();
